<ng-container *ngIf="!isSubmitted">
  <div *ngIf="!showRecorder">
    <div *ngIf="(!fileList.length || fileList.length > 1) && !source" class="d-block d-md-flex">
      <div class="record record--small position-relative">
        <!-- <span class="record__title record__title--large mg-b10">Ready to start?</span> -->
        <div class="record__block record__block--bordered-solid record__block--leftalign"
        *ngIf="(deviceInfo.os == 'Mac' || deviceInfo.os == 'iOS')  && (deviceService.isTablet() || deviceService.isMobile()) && deviceInfo.browser != 'Safari'; else showRecorderOption">
          <a href="javascript:void(0)" class="record__uploadtitle">To use our inbuilt recorder use Safari browser.</a>
        </div>
        <ng-template #showRecorderOption>
          <div (click)="runR()" class="record__block record__block--bordered-solid record__block--leftalign">
            <a href="javascript:void(0)" class="record__block__circlebtn">
              <i class="icon-record-audio"></i>
            </a>
            <a href="javascript:void(0)" class="record__uploadtitle">Record Audio</a>
          </div>
        </ng-template>
        <a href="javascript:void(0)" class="pt-3 pb-3 regular-link d-block" (click)="openQuickGuide()" *ngIf="!isMobile">Need help? Here’s a quick guide.</a>
      </div>
      <h3 class="heading18 text-md-left text-center pt-3 pb-3 pr-5 align-self-center">Or</h3>
      <div class="record record--small">
        <!-- <span class="record__title record__title--large mg-b10">Already have an audio file?</span> -->
        <div appDnd (filesChangeEmiter)="onFilesChange($event)" [allowed_extensions]="['mp3','wav','amr']"
          (filesInvalidEmiter)="filesInvalidEmiter($event)"
          class="record__block record__block--bordered position-relative  record__block--leftalign">
          <input (change)="onFilesChange($event.target.files)" accept="audio/*" type="file"
            class="droppable-file">
          <span class="record__block__circlebtn record__block__circlebtn--small">
            <i class="icon-audio-upload"></i>
          </span>
          <span class="record__subtitle mg-b5"><span
              class="record__uploadtitle record__uploadtitle--primary">Upload</span>
            an audio file</span>
        </div>
      </div>
    </div>
    <div *ngIf="fileList.length == 1 || source">
      <div class="record record--small pr-0 position-relative">
        <div class="record__block record__block--bordered-solid d-block" style="min-height: 0;">
          <div *ngIf="showProgress && !source" class="pd-t20 pd-b20">
            <div class="progress">
              <div class="progress-bar bg-success" [class.animated-progress]="progress!=100"
                [ngStyle]="{'width': progress+'%'}"></div>
            </div>
          </div>
          <div *ngIf="source">
            <a href="javascript:void(0)" (click)="show()" class="record__close"><i class="icon-delete-fill"></i></a>
            <div class="pt-5">
              <audio controls controlsList="nodownload" class="image-full" [src]="source| safeHtml"></audio>
            </div>
            <div *ngIf="showDeleteModal" class="delete-confirmation text-center">
              <div class="delete-confirmation__action">
                <a href="javascript:void(0)" (click)="hide()"
                  class="btn btn-about btn-outline-primary min-width209 mb-2 mx-1"><span>Cancel</span></a>
                <a href="javascript:void(0)" (click)="delete()"
                  class="btn btn-primary long-btn40 min-width209 mx-1 mb-2"><span>Yes,
                    Delete</span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="fileList.length > 1">
      <p class="error">Only One Audio can be selected.</p>
    </div>
  </div>
  <div class="audio-recorder">
    <a href="javascript:void(0)" (click)="reset()" *ngIf="showRecorder" class="record__close"><i
        class="icon-close"></i></a>
    <iframe #cameraTagIFrame style="overflow: hidden; width: 100%; border: medium none; height: 220px;" class="video-recorder"
      *ngIf="showRecorder" (load)="load()" allow="geolocation; microphone; camera"
      [src]="'assets/iframe/microphone.html?recorderId='+recorderId | safeHtml"></iframe>
  </div>
</ng-container>

<ng-container *ngIf="isSubmitted">
  <div [class.notanswered]="!source">
    <div class="record record--small pr-0">
      <div class="record__block record__block--bordered-solid d-block p-3" style="min-height: 0;">
        <audio *ngIf="source" controlsList="nodownload" controls class="image-full" [src]="source | safeHtml"></audio>
        <p class="text-center text-danger" *ngIf="!source">You haven't submitted your response for this item.</p>
      </div>
    </div>
  </div>

</ng-container>
<!-- Android Webview send file (audio) url -->
<button id="filePathId" (click)="sendRecordFilePath()" style="display: none;"></button> <br>
<!-- Android webview callback function for record audio file -->
<!-- <button type="checkbox" id="myCheck" onclick="getAndroidRecordFilePath('filePath')">test</button> -->
